
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiKeylinegrid as ObiKeylinegridElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-keylinegrid.js';
 
 
 

 
 export const ObiKeylinegrid = createComponent({
   react: React,
   tagName: 'obi-keylinegrid',
   elementClass: ObiKeylinegridElement,
   events: {
     
   }
  });
 
 